import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter, WithRouterProps } from 'react-router';

import { GlobalState } from 'ha/types/store';
import { getCurrentLanguageCode, getCurrentPageLanguages } from '../selectors';
import changeLanguage from '../actions/changeLanguage';
import LanguageSwitcher, { OwnProps } from '../components/LanguageSwitcher';

export default compose<React.ComponentType<OwnProps>>(
  withRouter,
  connect(
    (state: GlobalState, props: WithRouterProps) => ({
      selected: getCurrentLanguageCode(state),
      languages: getCurrentPageLanguages(state, props.location),
    }),
    {
      onChangeLanguage: changeLanguage,
    },
  ),
)(LanguageSwitcher);
